/**
 * Single source for API base URL. Same as login and all other API calls.
 * - Local dev (npm start on localhost): http://localhost:8000.
 * - Production (.env.production): REACT_APP_API_URL=https://config-go.com (baked into build).
 * - Deployed on config-go.com without env / bad bake: same origin (never localhost).
 */
function getApiUrl() {
  const isBrowser = typeof window !== 'undefined' && window.location;
  const hostname = isBrowser ? (window.location.hostname || '') : '';
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';

  if (isLocalHost) {
    return 'http://localhost:8000';
  }

  const envUrl = typeof process.env.REACT_APP_API_URL === 'string'
    ? process.env.REACT_APP_API_URL.trim().replace(/\/$/, '')
    : '';

  // Never ship a localhost API URL to a public host (bad .env bake).
  if (envUrl && !/localhost|127\.0\.0\.1/i.test(envUrl)) {
    return envUrl;
  }

  if (isBrowser) {
    return window.location.origin;
  }

  return envUrl || '';
}

export const API_URL = getApiUrl();
